var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hotkey--root text-monospace"},[(_vm.command)?_c('span',[_vm._v(_vm._s(_vm.commandKey)+" + ")]):_vm._e(),(_vm.shift)?_c('span',[_vm._v("Shift + ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }